var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('beast-header'),_vm._m(0),_c('beast-footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('h1',[_vm._v("403 You are not allowed!")]),_c('p',[_vm._v("You are not allowed to perform that action.")])])])])
}]

export { render, staticRenderFns }